<template>
  <el-container class="main_container">
    <el-main :class="{'ismobilePhone':isMobilePhone}">
      <p @click="goBack" style="cursor: pointer;">< Back</p>
      <el-row class="full_height bgw">
        <el-col
          :span="4"
          class="full_height bgw"
        >
          <el-menu
            class="full_height"
            :router='true'
            :default-active="$route.path"
          >
            <el-menu-item
              menuid="1001"
              index="/bond/base_info"
              :route="{path:'/bond/base_info', query:{'stockCode':stockCode}}"
            >Basic information</el-menu-item>
            <el-menu-item
              menuid="1002"
              index="/bond/issuance_status"
              :route="{path:'/bond/issuance_status', query:{'stockCode':stockCode}}"
            >Distribution</el-menu-item>
            <el-menu-item
              menuid="1004"
              index="/bond/cash_flow"
              :route="{path:'/bond/cash_flow', query:{'stockCode':stockCode}}"
            >Cash flow at maturity</el-menu-item>
            <el-menu-item
              menuid="1008"
              index="/bond/same_issuer"
              :route="{path:'/bond/same_issuer', query:{'stockCode':stockCode}}"
            >Same issuer</el-menu-item>
            <el-menu-item
              menuid="1010"
              index="/bond/sh_valuation"
              :route="{path:'/bond/sh_valuation', query:{'stockCode':stockCode}}"
            >Valuation of Shanghai Clearinghouse</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="20">
          <el-row
            class="bb bgw"
            align="center"
            style="height:60px;line-height:60px;padding:0 10px;"
          >
            <el-col :span="12">
              <div class="stockDiv">
                <span class="stockName">{{ stockName }}</span>
                <span class="stockCode">{{ stockCode }}</span>
                <span class="stockNowpage">{{ pageName}}</span>
              </div>
            </el-col>
            <el-col :span="3">
              <span class="stockNowpage">Switch bonds</span>
            </el-col>
            <el-col :span="6">
              <el-select
                v-model="stockinp"
                filterable
                remote
                placeholder="Please enter content"
                :remote-method="get_querykey"
                @change="handleChange"
                :loading="loading">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
              </el-select>
              <el-button style="border-radius: 0 3px 3px 0;margin-left: -3px;position: relative;" icon="el-icon-search" type="info" plain size="small"
                  @click.stop="handleSearch">
              </el-button>
              <!-- <el-input
                placeholder="Please enter content"
                v-model="stockinp"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click.stop="handleSearch"
                ></el-button>
              </el-input> -->
            </el-col>
            <el-col
              :span="3"
              style="text-align:right;"
            >
              <span class="icon"></span>
              <!-- Revised on 2022-03-05 -->
              <span
                class="text cursor-pointor"
                @click.stop="exportExcel"
                title="export Excel"
              >export Excel</span>
              <!-- Revised on 2022-03-05 -->
            </el-col>
          </el-row>
          <el-row class="bgw bond-container">
            <router-view ref="bondChild"></router-view>
          </el-row>
        </el-col>
      </el-row>

    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { get_querykey } from 'common/js/http/v3Api'

export default {
  name: "index",
  data() {
    return {
      activeIndex: '',
      isMobilePhone: false,
      stockinp: '',
      pageName: '',
      stockCode: '120303.SH',
      stockName: '03Three Gorges debt',
      loading: false,
      options: [],
      list: [],
    };
  },
  watch: {
    $route(e) {
      // 监听路由，当路由改变时获取到路由的name也就是菜单的index
      this.activeIndex = e.name
      switch (this.activeIndex) {
        case 'base_info':
          this.pageName = 'Basic information'
          break
        case 'issuance_status':
          this.pageName = 'Distribution'
          break
        case 'cash_flow':
          this.pageName = 'Cash flow at maturity'
          break
        case 'same_issuer':
          this.pageName = 'Same issuer'
          break
        case 'sh_valuation':
          this.pageName = 'Valuation of Shanghai Clearinghouse'
          break

      }
    }
  },
  created() {
    this.isMobile();
    this.isInSearch();
  },

  methods: {
    async get_querykey(query) {
      if (query !== '') {
        this.loading = true;
        this.list = [];
        const { data } = await get_querykey({
          queryKey: query,
        });
        if (data) {
          const list = data.result.data.filter(item => {
            return !item[1].includes('expired')
          });
          if (list && list.length !== 0) {

            this.list = list.map(item => {
              return {
                label: item[3] + ' ' + item[1],
                value: item[3],
                name: item[1]
              }
            });
            // const arr = []
            // list.forEach(element => {
            //   arr.push({label:element[3] + ' ' + element[1],value: element[3],name: element[1]})
            // });
            // this.list = arr;
            setTimeout(() => {
              this.loading = false;
              this.options = this.list.filter(item => {
                return item.label.toLowerCase()
                  .indexOf(query.toLowerCase()) > -1;
              });
              console.log(this.options,'options-options-options');
            }, 200);
          } else {
            this.loading = false;
            this.options = [];
          }
        }
      } else {
        this.options = [];
      }
    },
    handleChange(val) {
      this.stockCode = val;
      let self = this;
      this.list.forEach(item => {
        if (val == item.value) {
            self.stockName = item.name
        }
      });
      this.$refs.bondChild.searchTableData(this.stockinp)
    },
    goBack() {
      this.$router.push("/ChinaInformationV2/1");
    },
    isMobile() {
      this.isMobilePhone = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );

      //isMobilePhone 代表设备信息 转换bool
      this.setMobileStatus(!!this.isMobilePhone)
    },
    getBondList(v, cb) {
      cb([{ TRD_CODE: "010107", SECU_SHT: "21国债（7）", EXCH_NAME: "上海证券交易所" }, { TRD_CODE: "010107", SECU_SHT: "21国债（7）", EXCH_NAME: "上海证券交易所" }])
    },
    //search不展示主页效果
    isInSearch() {
      const queryLength = Object.keys(this.$route.query).length
      this.changeIndexShow(!queryLength);
    },
    /* Revised on 2022-03-05 */
    exportExcel() {
      this.$refs.bondChild.exportTableData()
    },
    handleSearch() {
      this.$refs.bondChild.searchTableData(this.stockinp)
    },
    /* Revised on 2022-03-05 */

    ...mapMutations(["setMobileStatus", "changeIndexShow"])
  }
};
</script>

<style scoped>
.el-main {
  padding: 0;
}
.ismobilePhone {
  padding: 0 !important;
  background: #fff !important;
}
.bgw {
  background: #fff !important;
}
.bb {
  box-sizing: border-box;
  border-bottom: 1px solid #cacaca;
}
.stockName,
.stockCode {
  font-size: 20px;
  font-weight: bold;
  margin-right: 10px;
}
.stockDiv {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow:ellipsis;
}
.stockNowpage {
  display: inline-block;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 100;
  height: 40px;
  line-height: 38px;
}
.stock-search {
  width: 320px;
  height: 100%;
  float: right;
  margin-right: 20px;
  line-height: 36px;
  font-size: 16px;
  color: #555;
  position: relative;
}
.bond-container {
  height: calc(100vh - 175px);
}

::v-deep .my-autocomplete {
  min-width: 300px;
}
::v-deep .my-autocomplete li {
  padding: 2px;
  background-color: aqua;
  display: inline-block;
  width: 100%;
}
::v-deep .my-autocomplete li .searchCode {
  width: 20%;
  display: inline-block;
  text-align: center;
}
::v-deep .my-autocomplete li .searchName {
  width: 40%;
  display: inline-block;
  text-align: center;
}
::v-deep .my-autocomplete li .searchMask {
  width: 40%;
  display: inline-block;
  text-align: center;
}
.icon {
  width: 14px;
  height: 15px;
  display: inline-block;
  position: relative;
  top: 35%;
  left: -5px;
  background-repeat: no-repeat;
  background-image: url("./components/ArticleDetails/assets/white_theme/export.png");
}
.export-row {
  height: 40px;
  line-height: 40px;
  background: #fff;
  font-size: 16px;
  flex-wrap: wrap;
  flex-direction: row;
  padding-right: 10px;
}
.cursor-pointor {
  cursor: pointer;
}
</style>
